"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var Post_1 = __importDefault(require("./posts/post-types/Post"));
window.addEventListener('DOMContentLoaded', function () {
    var postContainer = document.querySelector('#post-container');
    var queryString = window.location.search;
    var urlParameters = new URLSearchParams(queryString);
    var category = null;
    if (urlParameters.has('categories')) {
        var cat = urlParameters.get('categories');
        category = {
            name: "categories",
            id: parseInt(cat),
        };
    }
    if (postContainer) {
        var element = (react_1.default.createElement("div", null,
            react_1.default.createElement(Post_1.default, { postsPerPage: 9, postType: "posts", includeIndustry: true, categories: [
                    {
                        name: "categories",
                        type: "dropdown",
                    }
                ], selectedCategories: category ? [category] : null })));
        react_dom_1.default.render(element, postContainer);
    }
});
